// extracted by mini-css-extract-plugin
module.exports = {"section":"RelatedPosts_section__QxvEi","kicker":"RelatedPosts_kicker__Od5qU","title":"RelatedPosts_title__YbrCn","list":"RelatedPosts_list__3BlJq"};